export default __webpack_public_path__ + "static/media/star.323077d9.svg";